import Radio from "@material-ui/core/esm/Radio";
import RadioGroup from "@material-ui/core/esm/RadioGroup";
import FormControlLabel from "@material-ui/core/esm/FormControlLabel";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddressFormSection from 'components/AddressFormSection/AddressFormSection';
import { Header } from 'components/Text';
import AddressTypes from 'constants/addressTypes';
export default function CreateCustomerAddresses() {
  const {
    t
  } = useTranslation();
  const [identicalAddresses, setIdenticalAddresses] = useState(true);
  const handleRadioGroupChange = event => {
    const {
      value
    } = event.target;
    if (value === 'true') {
      setIdenticalAddresses(true);
    } else setIdenticalAddresses(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, null, t('address.billing_address')), /*#__PURE__*/React.createElement(AddressFormSection, {
    addressType: AddressTypes.BILLING,
    isNewCustomer: true
  }), /*#__PURE__*/React.createElement(Header, null, t('address.shipping_address')), /*#__PURE__*/React.createElement(RadioGroup, {
    "aria-label": "select to use billing address",
    name: "identicalAddresses",
    value: identicalAddresses,
    onChange: handleRadioGroupChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: true,
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: t('address.repeat_billing_address')
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: false,
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: t('address.another_address')
  })), !identicalAddresses && /*#__PURE__*/React.createElement(AddressFormSection, {
    addressType: AddressTypes.SHIPPING,
    isNewCustomer: true
  }));
}